export default {
  title: 'Uusi hinta',
  fields: {
    product: {
      label: 'Tuote',
    },
    is_not_personal: {
      label: 'Näkyy kaikille',
    },
    is_default: {
      label: 'Oletus',
    },
    visible_to: {
      label: 'Näkyy henkilöille',
    },
  },
  buttons: {
    select_all: 'Valitse kaikki',
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  feedback: {
    missing_info: 'Puuttuvia tietoja',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    price_got_created: 'Hinta luotu',
    price_got_updated: 'Hinta päivitetty',
  },
};
